/** Papan pemuka pegawai, bar bahagian Perancangan, halaman tiada akses dan paparan aktiviti pentadbir (pelan F3). */
export default {
  dashboard: {
    title: 'Papan pemuka Perancangan',
    subtitle: 'Penyerahan, semakan dan kelulusan secara ringkas.',
    nav: {
      label: 'Bahagian Perancangan',
      dashboard: 'Papan pemuka',
      submissions: 'Penyerahan',
      mySubmissions: 'Penyerahan saya',
      registrations: 'Pendaftaran',
      activity: 'Aktiviti',
      settings: 'Tetapan',
    },
    noAccessTitle: 'Tiada akses kepada Perancangan',
    noAccessBody:
      'Akaun anda tiada peranan Perancangan. Minta pentadbir menambah anda ke kumpulan penyemak atau pelulus, atau meluluskan pendaftaran pemohon anda.',
    noAccessHome: 'Kembali ke Laman Utama',
    quickActions: 'Tindakan pantas',
    newSubmission: 'Penyerahan baharu',
    openStaging: 'Buka Peta Staging',
    openApproved: 'Buka Peta Diluluskan',
    mapsMissing: 'Peta perancangan akan wujud selepas Tetapan → Perancangan disimpan.',
    cards: {
      all: 'Semua penyerahan',
      awaiting: 'Menunggu semakan',
      approved: 'Diluluskan',
      returned: 'Dikembalikan',
      failed: 'Gagal semakan',
      withdrawn: 'Ditarik balik',
      committee: 'Di jawatankuasa',
      refused: 'Ditolak',
      in_force: 'Kebenaran berkuat kuasa',
    },
    conversion: 'Semakan terkini setiap penyerahan',
    conversionInProgress: 'Dalam proses',
    conversionPassed: 'Lulus',
    conversionFailed: 'Gagal',
    conversionErrored: 'Tidak dapat dijalankan',
    successRate: 'Kadar kejayaan',
    successRateHint: 'Lulus ÷ (lulus + gagal). Semakan yang tidak dapat dijalankan tidak dikira.',
    successRateNone: 'Belum ada semakan yang selesai',
    storage: 'Storan digunakan',
    storageHint: 'Lukisan dan fail terbitan; fail yang disimpan untuk beberapa versi dikira sekali.',
    byStage: 'Mengikut peringkat',
    crsUsage: 'Sistem koordinat',
    crsUnknown: 'EPSG {{srid}} (tiada dalam pek)',
    none: 'Belum ada.',
    recent: 'Penyerahan terkini',
    recentEmpty: 'Belum ada penyerahan.',
    viewAll: 'Lihat semua penyerahan',
  },
  activity: {
    title: 'Aktiviti Perancangan',
    subtitle:
      'Siapa melakukan apa dalam Perancangan, yang terbaharu dahulu. Masa, alamat IP dan pelayar dipaparkan jika direkodkan.',
    notPermitted: 'Hanya pentadbir penyewa boleh melihat aktiviti Perancangan.',
    filterLabel: 'Tindakan',
    allActions: 'Semua tindakan',
    columns: {
      time: 'Masa',
      action: 'Tindakan',
      actor: 'Oleh',
      target: 'Perkara',
      ip: 'Alamat IP',
      userAgent: 'Pelayar (ejen pengguna)',
    },
    system: 'Sistem',
    empty: 'Belum ada aktiviti Perancangan direkodkan.',
    loadMore: 'Muat lagi',
    loadingMore: 'Memuatkan…',
    targets: {
      planning_case: 'Penyerahan',
      planning_document: 'Fail',
      planning_registration: 'Pendaftaran',
      planning_settings: 'Tetapan',
      planning_import: 'Import pakej',
      planning_trusted_system: 'Sistem dipercayai',
      planning_register_export: 'Eksport daftar daerah',
      planning_letter: 'Surat keputusan',
      user: 'Orang',
    },
    actions: {
      case_created: 'Penyerahan dicipta',
      case_updated: 'Penyerahan disunting',
      case_submitted: 'Dihantar',
      case_resubmitted: 'Dihantar semula',
      case_check_retried: 'Semakan dicuba semula',
      case_approved: 'Diluluskan',
      case_returned: 'Dikembalikan',
      case_withdrawn: 'Ditarik balik',
      case_deleted: 'Dipadam',
      document_uploaded: 'Lukisan dimuat naik',
      document_downloaded: 'Fail dimuat turun',
      register_retried: 'Kemas kini peta dicuba semula',
      registration_approved: 'Pendaftaran diluluskan',
      registration_rejected: 'Pendaftaran ditolak',
      registration_password_issued: 'Kata laluan sementara dikeluarkan',
      settings_updated: 'Tetapan dikemas kini',
      chain_broken: 'Sejarah gagal pengesahan',
      calendar_updated: 'Kalendar hari bekerja dikemas kini',
      procedure_updated: 'Pelarasan prosedur disimpan',
      case_exported: 'Eksport pakej kes dimohon',
      case_export_downloaded: 'Pakej kes dimuat turun',
      case_authority_recalled: 'Kes ditarik balik daripada sistem lain',
      seal_key_rotated: 'Kunci tandatangan pakej diganti',
      import_validated: 'Pakej kes disemak',
      case_imported: 'Pakej kes diimport',
      case_external_id_linked: 'Rujukan luar dipautkan',
      trusted_system_updated: 'Sistem dipercayai disimpan',
      trusted_system_deleted: 'Sistem dipercayai dibuang',
      case_transition: 'Langkah prosedur diambil',
      case_referral_requested: 'Ulasan teknikal dipohon',
      case_referral_answered: 'Ulasan teknikal diterima',
      case_referral_withdrawn: 'Permohonan ulasan ditarik balik',
      case_linked: 'Penyerahan dipautkan',
      case_unlinked: 'Pautan penyerahan dibuang',
      case_assigned: 'Penyerahan ditugaskan',
      case_intake_tool: 'Alat semakan pelan digunakan',
      letter_prepared: 'Surat keputusan disediakan',
      letter_issued: 'Surat keputusan dikeluarkan',
      letter_discarded: 'Draf surat keputusan dibuang',
      letter_shared: 'Surat keputusan dikongsi dengan pemohon',
      letter_unshared: 'Surat keputusan disembunyikan daripada pemohon',
      letter_email_released: 'E-mel keputusan yang ditahan dilepaskan',
      letter_signed: 'Surat keputusan bertandatangan disahkan',
      signing_certificate_requested: 'Sijil tandatangan diminta',
      signing_certificate_ready: 'Sijil tandatangan sedia',
      signing_certificate_status_changed: 'Sijil tandatangan dihidupkan atau dimatikan',
      signing_certificate_approved: 'Sijil tandatangan peribadi diluluskan',
      signing_certificate_deleted: 'Sijil tandatangan dipadam',
      letter_sign_requested: 'Surat keputusan dihantar untuk ditandatangani dalam gisify',
      register_exported: 'Eksport daftar daerah diminta',
      register_export_downloaded: 'Eksport daftar daerah dimuat turun',
      case_external_id_unlinked: 'Pautan rujukan luar dibuang',
      case_mirror_marked: 'Senarai semak salinan OSC dikemas kini',
      notification_test_sent: 'E-mel ujian dihantar',
      notification_resent: 'E-mel digilirkan semula',
      notification_preferences_updated: 'Keutamaan e-mel ditukar',
    },
  },
} as const
